import z from 'zod'

import { zh } from '@/libs/utils/zod'

export const UomDto = z.object({
  code: z.string(),
  ...zh.metadata.shape,
})

export type UomDto = z.infer<typeof UomDto>
